module.exports = __webpack_public_path__ + "img/screen_setting_bg.7296d2ea.jpg";